'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Thumbnail-module_thumbnail__-euUZ{background-position:50%;background-size:cover;border-radius:4px;display:inline-block;height:5rem;margin:0 auto;width:5rem}";
var styles = {"thumbnail":"Thumbnail-module_thumbnail__-euUZ"};
styleInject["default"](css_248z, '9ddc3b93-4ec3-4c6b-9bb0-4988a3fba147');

exports["default"] = styles;
